import {VerificationStepType} from "../verification/VerificationStepType";

export class MismatchedStepError extends Error {
    correctStep: VerificationStepType

    constructor(correctStep: VerificationStepType) {
        super();
        this.correctStep = correctStep;
    }
}